<div class="container-fluid">
  <div class="row row-padding-top">
    <div class="col"></div>
    <div class="col-auto">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
      ></button>
    </div>
  </div>
  <div class="row">
    <div class="col d-flex justify-content-center">
      <h3>Signed Document Files</h3>
    </div>
  </div>
  @for (PreSignedUrl of PreSignedUrls; track PreSignedUrl) {
    <div class="row row-padding">
      <div class="col-12">
        <button
          (click)="downloadS3File(PreSignedUrl)"
          class="btn btn-primary h-100"
        >
          {{ PreSignedUrl.filename }}
        </button>
      </div>
    </div>
  }
  <div class="row row-padding-bottom justify-content-center">
    <div class="col-6">
      <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
  </div>
</div>
